import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import api from '../../api/axios';
import { Form, Button, Alert, Container, Row, Col, Card } from 'react-bootstrap';
import '../../styles/form.css';
import logo1 from "../../assets/logo/logo-login.png";
const LoginForm = () => {
  const [form, setForm] = useState({ email: '', password: '' });
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleChange = e => {
    setForm({ ...form, [e.target.name]: e.target.value });
    setError('');
  };

  const validateEmail = email => {
    const regex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    return regex.test(email);
  };

  const handleSubmit = async e => {
    e.preventDefault();

    const { email, password } = form;
    if (!email || !password) {
      setError('Completá todos los campos.');
      return;
    }

    if (!validateEmail(email)) {
      setError('El email no es válido.');
      return;
    }

    try {
      setLoading(true);
      const res = await api.post('/users/login', form);
      const { token, user, business } = res.data;

      localStorage.setItem('token', token);
      localStorage.setItem('user', JSON.stringify(user));
      if (business) {
        localStorage.setItem('business', JSON.stringify(business));
      }

      if (user.role === 'ADMIN' && business) {
        navigate(`/admin/${business.slug}`);
      } else if (user.role === 'CONSUMER') {
        navigate('/'); // consumidores vuelven a la home
      } else {
        setError('Este usuario no tiene acceso en QR Benefits');
      }
    } catch (err) {
      const msg = err.response?.data?.message || 'Error al iniciar sesión';
      setError(msg);
      console.error('Error en login:', err);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-page">
      <Container>
        <Row className="justify-content-center">
          <Col md={6} lg={4}>
            <Card className="shadow-lg login-card">
              <Card.Body className="p-4">
                <div className="text-center mb-4">
                  <img
                    src= {logo1}
                    alt="Logo qrBenefits"
                    style={{ maxWidth: '120px' }}
                    className="mb-3"
                  />
                  <h3 className="mb-1">Iniciar sesión</h3>
                  <p className="text-muted mb-0" style={{ fontSize: '0.9rem' }}>
                    Accedé a tu panel de beneficios
                  </p>
                </div>

                {error && (
                  <Alert variant="danger" className="py-2">
                    {error}
                  </Alert>
                )}

                <Form onSubmit={handleSubmit}>
                  <Form.Group className="mb-3" controlId="email">
                    <Form.Label>Email</Form.Label>
                    <Form.Control
                      type="email"
                      name="email"
                      placeholder="Ingresá tu email"
                      value={form.email}
                      onChange={handleChange}
                      required
                    />
                  </Form.Group>

                  <Form.Group className="mb-4" controlId="password">
                    <Form.Label>Contraseña</Form.Label>
                    <Form.Control
                      type="password"
                      name="password"
                      placeholder="Ingresá tu contraseña"
                      value={form.password}
                      onChange={handleChange}
                      required
                    />
                  </Form.Group>

                  <Button
                    type="submit"
                    className="w-100 btn-qr-primary"
                    disabled={loading}
                  >
                    {loading ? 'Ingresando...' : 'Entrar'}
                  </Button>
                </Form>

                <div className="text-center mt-3">
                  <small className="text-muted">
                    ¿No tenés cuenta?{' '}
                    <button
                      type="button"
                      className="btn btn-link p-0 text-qr-primary"
                      onClick={() => navigate('/register-consumer')}
                    >
                      Registrate acá
                    </button>
                  </small>
                </div>
              </Card.Body>
            </Card>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default LoginForm;
